export const desktopStyles = {
    header: "fixed z-[100] top-0 right-0 left-0 h-[115px] bg-mdlzPurple",
    borderBottom: "header-border-bottom bg-mdlzPurple z-[101]",
    wrapper: "relative section-wrapper flex items-center justify-between gap-[15px] h-full pt-[20px] md:pt-[35px]",
    mainCtaWrapper: "xl:ml-[87px]",
    logoWrapper: "w-[170px]",
    desktopContent: "hidden lg:flex flex-row gap-[16px] xl:gap-[25px] h-full items-center text-white",
    menuElement: "relative h-full flex items-center",
    menuLink: "btn-menu-dark font-bold",
    dropdown: "absolute top-full left-0 w-fit",
    dropdownInner:
        "relative top-0 rounded-b-[10px] px-[20px] pt-[50px] pb-[20px] flex flex-col gap-2 text-black bg-white",
    dropdownLink: "btn-menu font-bold",
}

export const mobileStyles = {
    header: "fixed z-[100] top-0 right-0 left-0 h-[75px] md:h-[115px] bg-mdlzPurple print:hidden",
    borderBottom: "header-border-bottom bg-mdlzPurple z-[101]",
    wrapper: "relative section-wrapper flex items-center justify-between gap-[15px] h-full md:pt-[17px]",
    content: "flex flex-row items-center gap-[11px]",
    mainCtaWrapper: "hidden sm:flex",
    logoWrapper: "w-[115px] md:w-[170px]",
    mobileMenuButton: "flex w-[24px] h-[24px] items-center justify-center",
    mobileNavigation:
        "absolute bg-white z-[90] top-full w-full max-w-[754px] lg:max-w-[1040px] left-1/2 translate-x-[-50%] transform transition-all duration-300 rounded-b-[20px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
    mobileNavigationHidden: "opacity-0 pointer-events-none",
    mobileNavigationVisible: "opacity-100 pointer-events-auto",
    mobileNavigationInner: "mx-auto w-full",
    mobileNavList: "flex flex-col gap-[18px] w-full pt-[50px] px-[20px] pb-[32px]",
    navigationButton: "btn-menu font-bold w-full flex flex-row justify-between gap-[5px]",
}
